<template>
	<div class="buybox-no-offers" :class="{ 'v-3': buyRentExpVariant === 'variant_3' }">
		<div class="buybox-no-offers__text">
			<p class="buybox-no-offers__text__title">{{ $t('WEBAPP_NOTIFY_ME_NEW_TITLE') }}</p>
			<p class="buybox-no-offers__text__subtitle">{{ $t('WEBAPP_NOTIFY_ME_NEW_TEXT') }}</p>
		</div>

		<BasicButton class="buybox-no-offers__button" @click="onNotifyMe">
			<div class="buybox-no-offers__button__content">
				<FontAwesomeIcon
					class="buybox-no-offers__button__content__icon"
					:class="{ primary: isTitleInWatchlist }"
					:icon="isTitleInWatchlist ? jwCheckIcon : faBell"
					size="2x"
					fixed-width
				/>
				<span>{{ $t('WEBAPP_BUTTON_NOTIFY_ME') }}</span>
			</div>
		</BasicButton>
	</div>
</template>

<script setup lang="ts">
import { SnowplowContext } from '@/helpers/tracking/providers';
import { TitleDetail } from '@/interfaces/title-details-graphql';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';

import { BuyBoxFilterOptions } from '@/stores/useUserStoreTypes';
import { jwCheckIcon } from '@/plugins/global-fontawesome';
import { faBell } from '@fortawesome/free-solid-svg-icons';

import BasicButton from '@/ui-components/BasicButton.vue';
import { useExperiment } from '@/libraries/experiment';

const props = withDefaults(
	defineProps<{
		isTitleInWatchlist: boolean;
		title: TitleDetail;
		filter: BuyBoxFilterOptions;
		additionalContexts: SnowplowContext[];
	}>(),
	{
		isTitleInWatchlist: false,
		additionalContexts: () => [],
	}
);

const emit = defineEmits<{
	(e: 'onNotifyMe'): void;
}>();

const { activeVariantWithControlGroup: buyRentExpVariant } = useExperiment('EXP_MERGE_BUY_RENT');
const onNotifyMe = () => {
	emit('onNotifyMe');

	let offerType = '';
	switch (props.filter) {
		case 'free':
			offerType = 'free';
			break;
		case 'cinema':
			offerType = 'cinema';
			break;
		default:
			offerType = 'streaming';
			break;
	}

	TrackingHelper.trackEvent('userinteraction', {
		action: 'notify_me_clicked',
		label: offerType,
		value: !props.isTitleInWatchlist ? 1 : 0,
	});
};
</script>

<style lang="scss" scoped>
.buybox-no-offers {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 16px;
	background: #111924;
	height: 104px;

	@media (max-width: 767px) {
		flex-direction: column;
		align-items: center;
		gap: 16px;
		height: auto;
		justify-content: flex-start;
	}

	&__text {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: flex-start;
		text-align: start;

		@media (max-width: 767px) {
			text-align: center;
		}

		&__title {
			width: 100%;
			margin: 0;
			margin-bottom: 8px;
			color: #c6c8cd;
			font-size: 14px;
			font-weight: 900;
			line-height: 24px;
			letter-spacing: 0.24px;
		}

		&__subtitle {
			margin: 0;
			color: #c6c8cd;
			font-size: 14px;
			line-height: 16px;
			letter-spacing: 0.21px;
		}
	}
	&__button {
		height: 40px;
		min-width: 166px;
		padding: 8px 16px;
		border-radius: 8px;
		border: none;
		background: #303740;
		color: #c6c8cd;
		font-size: 16px;
		font-weight: 900;
		letter-spacing: 0.24px;
		cursor: pointer;

		&:hover {
			background: #303740cb;
		}

		@media (max-width: 800px) {
			// padding: 8px;
			width: fit-content;
		}

		&__content {
			display: flex;
			align-items: center;
			justify-content: center;
			gap: 8px;

			&__icon {
				height: 16px;
				width: 16px;
				&.primary {
					color: var(--jw-yellow-500);
				}
			}
		}
	}
}

.jw-logo {
	width: 16px;
	height: 16px;
}

// EXP MERGE BUY RENT
.v-3 {
	@media (min-width: 1050px) {
		border-bottom-left-radius: 8px;
		border-bottom-right-radius: 8px;
	}
}
// EXP MERGE BUY RENT
</style>
